import { useMemo } from "react";
import useAuth from "../../../auth/useAuth";
import { companiesListRoute } from "../../../config";
import { useFetchGET } from "../../../state/FetchHelpers";
import { STATUSES_NUM } from "../../../utils/Constants";

export const useCompanies = (reloadData: boolean) => {

    const auth = useAuth();
    const token = auth.globals.token;
    const allowedCompanies = auth.globals.companies;

    const { data: rawCompanyListData, loading: companyListLoading, error: companyListError } = useFetchGET(companiesListRoute(STATUSES_NUM.ACTIVE), token, [], reloadData);

    const companyListData = useMemo(() => {
        if (!Array.isArray(allowedCompanies) || allowedCompanies.length === 0) return rawCompanyListData;
        const allowedIds = new Set(allowedCompanies.map(Number));
        return rawCompanyListData.filter((company: { id: number }) => allowedIds.has(company.id));
    }, [rawCompanyListData, allowedCompanies]);

    return {
        //properties
        companyListData,
        companyListLoading,
        companyListError
    }
}